// GetPageMetaData returns the meta data for a article detail page.
export const ArticleDetailMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailMetaService_GetPageMetaData
  );
ArticleDetailMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.article_detail_page.v1.meta.ArticleDetailMetaService/GetPageMetaData" as const;
